/**
 * Technology Table Column Constants
 *
 * Column configuration constants extracted from config/columns.ts
 * These are static values that don't change and represent core table behavior.
 */

/**
 * Default column order for technology table
 *
 * Ordering convention:
 * 1. Core columns - Vendor, Technology (name)
 * 2. Metadata columns - Tags
 * 3. Date columns - First Seen, Last Seen always at end when present (user can remove or reorder)
 *
 * Note: This is the DEFAULT order. Users have full control to reorder or remove any column
 * except 'name' which is required.
 */
export const TECHNOLOGY_DEFAULT_COLUMN_ORDER = [
  'vendor', // Core: Vendor name
  'name', // Required: Cannot be removed
  'created', // Convention: Date columns last by default
  'visited', // Convention: Date columns last by default
] as const;

/**
 * Columns that support sorting
 * Columns not in this list will have sorting disabled
 *
 * IMPORTANT: These column IDs MUST match the backend's AllowedColumns map
 * in modules/chariot/backend/build/pkg/query/allowed_columns.go
 *
 * Backend validation will reject queries with invalid orderBy fields.
 *
 * Note: 'tags' is not sortable as it's a multi-value field
 */
export const SORTABLE_COLUMNS = [
  'vendor',
  'name',
  'created',
  'visited',
] as const;

/**
 * Column ID that must always be visible (cannot be removed)
 */
export const REQUIRED_COLUMN_ID = 'name' as const;
